import MainListItemCard from "../../../../Component/Elements/MainListItemCard/MainListItemCard";
import Text from "../../../../Component/Elements/Text/Text";
import useEventApplication from "../../hooks/useEventApplication.hook";
import { joinedEventType } from "../../static/interface/PhotoList.interface";
import CSS from "./static/css/PhotoListItemCard.module.css";

const PhotoListItemCard = (
    {
        img_url,
        title,
        info,
        upload_date,
        new_download_file_count,
        joined_event,
        onClick,
    }:{
        img_url: string;
        title: string;
        info: string;
        upload_date: string;
        new_download_file_count: number;
        joined_event: joinedEventType;
        onClick?: React.MouseEventHandler<HTMLDivElement>
    }
) => {
    const {
        state,
    } = useEventApplication({
        upload_date: upload_date,
        joined_event: joined_event,
        // [isEventApplication 제거 - 2026-05-06 khm] useEventApplication 훅으로의 전달
        // isEventApplication,
    });

    return(
        <MainListItemCard
            img_src={img_url}
            onClick={onClick}
            thumbnail_no_padding={true}
            img_object_fit={"cover"}
        >
            <div className={CSS.PhotoListItemCard_container}>
                <div className={CSS.PhotoListItemCard_mainContentContainer}>
                    <Text
                        preset={"content_title"}
                        is_text_truncation_on={true}
                    >
                        {title}
                    </Text>
                    <Text
                        is_text_truncation_on={true}
                    >
                        {info}
                    </Text>
                    {
                        new_download_file_count > 0
                        ?   <Text
                                is_text_truncation_on={true}
                                class_name_list={[CSS.PhotoListItemCard_downloadAlertText]}
                            >
                                다운로드 하지 않은 사진
                            </Text>
                        :   null
                    }

                    {
                        state.state == 1
                        ?   <Text
                                is_text_truncation_on={true}
                                class_name_list={[CSS.PhotoListItemCard_joinedEventAlertText]}
                            >
                                후기 이벤트 신청 가능
                            </Text>
                        :   null
                    }
                </div>

                <div>
                    <Text
                        color={"gray3"}
                        is_text_truncation_on={true}
                    >
                        {upload_date}
                    </Text>
                </div>
            </div>
        </MainListItemCard>
    )
}

export default PhotoListItemCard;